import { log as logtail } from "@logtail/next";

/**
 * Log function signature matching BetterStack/Logtail's Logger interface.
 * Format: log.info("message", { optional: "context" })
 */
type LogFn = (message: string, args?: { [key: string]: any }) => void;

/**
 * Application logger interface matching BetterStack/Logtail's Logger.
 * This ensures consistent behavior between production and development.
 */
export interface AppLogger {
  info: LogFn;
  warn: LogFn;
  error: LogFn;
  debug: LogFn;
}

/**
 * Development logger that implements AppLogger interface
 * using console methods for local development.
 * Matches BetterStack/Logtail's logging format.
 */
const devLogger: AppLogger = {
  info: (message, args) => console.info(message, args),
  warn: (message, args) => console.warn(message, args),
  error: (message, args) => console.error(message, args),
  debug: (message, args) => console.debug(message, args),
};

/**
 * Unified logger for the monorepo.
 * - Production: Uses Logtail/BetterStack for structured logging
 * - Development: Uses console with the same interface
 *
 * Usage: log.info("message", { key: "value" })
 */
export const log: AppLogger =
  process.env.NODE_ENV === "production" ? logtail : devLogger;
